<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false' v-model:value="active">
      <a-tabs  v-model:activeKey="active">
        <a-tab-pane key="1" tab="微信图文">
          <wxImgText></wxImgText>
        </a-tab-pane>
        <a-tab-pane key="2" tab="高级图文">
          <highImgText></highImgText>
        </a-tab-pane>
        <a-tab-pane key="3" tab="小程序卡片">
          <wxCard></wxCard>
        </a-tab-pane>
        <a-tab-pane key="4" tab="图片素材">
        <material ></material>
        </a-tab-pane>
         <a-tab-pane key="5" tab="音频素材">
        <!-- <material ></material> -->
        <audioList></audioList>
        </a-tab-pane>
         <a-tab-pane key="6" tab="视频素材">
        <!-- <material ></material> -->
        <videoList></videoList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import wxImgText from './components/wx_imgText';
import highImgText from './components/high_imgText';
import wxCard from './components/wx_card';
import material from './components/material'
import audioList from './components/audio_list'
import videoList from './components/video_list'
export default {
  components: {wxImgText,highImgText,wxCard,material,audioList,videoList },
  setup(props) {
    const state = reactive({
active:'1'
    });
    const $router = inject('$router')
    const $route = inject('$route')
    const $Modal = inject('$Modal')
    
    onMounted(() => {
      if($route.query.active){
          state.active=$route.query.active
      }
    });
    return {
      ...toRefs(state)
    };
  },
};
</script>